module.exports = __webpack_public_path__ + "static/media/food-chain-asparagus-pickers-mobile.a071f36d.jpg";